import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Store } from '@ngrx/store';
import { PickSourceProvider } from 'packages/sports/web/app/src/option-pick/pick-source.provider';
import { Observable } from 'rxjs';

import { RewardTokensActions } from '../../actions';
import { IRewardToken, RewardTokenContext } from '../../reward-tokens.model';
import { selectRewardsTokensSelectorState } from '../../selectors';

interface ViewModel {
    isVisible: boolean;
    selectedToken: IRewardToken | null;
    isTokenInvalid: boolean;
    hasAcquisitionOnboarding: boolean;
}
@Component({
    selector: 'bs-reward-tokens-selector-container',
    templateUrl: './reward-tokens-selector-container.component.html',
    styleUrls: ['./reward-tokens-selector-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class RewardTokensSelectorContainerComponent implements OnChanges {
    @Input() tokenContext: RewardTokenContext;
    @Input() infoEnabled = false;

    vm$: Observable<ViewModel>;

    constructor(
        private store: Store,
        private pickSourceProvider: PickSourceProvider,
    ) {}

    ngOnChanges(simpleChanges: SimpleChanges): void {
        const contextChanges = simpleChanges['tokenContext'];
        const previous = contextChanges?.previousValue;
        const current = contextChanges?.currentValue;

        if (
            !this.tokenContext ||
            !contextChanges ||
            (current?.betslipType === previous?.betslipType && current?.pickId?.toString() === previous?.pickId?.toString())
        ) {
            return;
        }

        this.vm$ = this.store.select(selectRewardsTokensSelectorState(this.tokenContext));
    }

    onSelectorClick(): void {
        this.store.dispatch(
            RewardTokensActions.openDialog({
                tokenContext: this.tokenContext,
                trackingSource: this.pickSourceProvider.getTracking(),
            }),
        );
    }

    onInfoClick(): void {
        this.store.dispatch(
            RewardTokensActions.showOverlayInfo({ trackingSource: this.pickSourceProvider.getTracking(), tokenContext: this.tokenContext }),
        );
    }
}
